module.exports = __webpack_public_path__ + "static/media/angle-next.b75c9090.svg";